import React from 'react';
import {  FaPhone, FaEnvelope, FaMapMarkerAlt, FaFacebook, FaInstagram, FaTiktok } from 'react-icons/fa';

const Footer = () => {
  // const currentYear = new Date().getFullYear();

  const footerLinks = {
    services: [
      "Dentisterie générale",
      "Dentisterie esthétique",
      "Implants dentaires",
      "Orthodontie",
      "Dentisterie pédiatrique",
      "Soins d'urgence"
    ],
    about: [
      { name: 'À propos', id: 'about' },
      { name: 'Services', id: 'services' },
      { name: 'Équipe', id: 'team' }
    ],
    support: [
      "Patient Forms",
      "Insurance Info",
      "Payment Options",
      "Emergency Care",
      "FAQ",
      "Contact Us"
    ]
  };


  const socialLinks = [
    { icon: <FaFacebook />, href: "https://www.facebook.com/share/1Cp3AWCMST/", label: "Facebook" },
    { icon: <FaInstagram />, href: "https://www.instagram.com/dr.youssef.lachhab/", label: "Instagram" },
    { icon: <FaTiktok />, href: "https://www.tiktok.com/@dr.youssef.lachhab?_t=ZS-8z93UrnxoJR&_r=1", label: "TikTok" }
  ];

  
  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer Content */}
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-semibold mb-6 text-white">Contact</h3>

            {/* Contact Info */}
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <FaPhone className="text-primary-400" />
                <span className="text-gray-300">07 08 44 44 54</span>
              </div>
              <div className="flex items-center space-x-3">
                <FaEnvelope className="text-primary-400" />
                <span className="text-gray-300">
                  drlachhab.youssef@gmail.com
                </span>
              </div>
              <div className="flex items-center space-x-3">
                <FaMapMarkerAlt className="text-primary-400" />
                <span className="text-gray-300">
                  Temara, Av Moulay Rachid, Lot Khiam 06, Hay Al Inbiat, № 22,
                  1er étage
                </span>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-xl font-semibold mb-6 text-white">
              Nos Services
            </h3>
            <ul className="space-y-3">
              {footerLinks.services.map((service, index) => {
                const slug = service.toLowerCase().replace(/\s+/g, "-");

                return (
                  <li key={index}>
                    <a
                      href={`#${slug}`}
                      className="text-gray-300 hover:text-primary-400 transition-colors duration-300"
                    >
                      {service}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>

          {/* About */}
          <div>
            <h3 className="text-xl font-semibold mb-6 text-white">
              À propos de nous
            </h3>
            <ul className="space-y-3">
              {footerLinks.about.map((item) => (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    className="text-gray-300 hover:text-primary-400 transition-colors duration-300"
                  >
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Hours & Social */}
          <div>
            <h3 className="text-xl font-semibold mb-6 text-white">
              Horaires d'ouverture
            </h3>
            <div className="space-y-3 mb-8">
              <div className="flex justify-between">
                <span className="text-gray-300">Lundi - Vendredi</span>
                <span className="text-gray-300">9h00 - 19h00</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-300">Samedi</span>
                <span className="text-gray-300">9h00 - 14h00</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-300">Dimanche</span>
                <span className="text-gray-300">Fermé</span>
              </div>
              <div className="pt-2 border-t border-gray-700">
                <div className="flex justify-between">
                  <span className="text-red-400 font-semibold">
                    Soins d'urgence
                  </span>
                  <span className="text-red-400 font-semibold">24h/24</span>
                </div>
              </div>
            </div>

            {/* Social Links */}
            <div>
              <h4 className="text-lg font-semibold mb-4 text-white">
                Suivez-nous
              </h4>
              <div className="flex space-x-4">
                {socialLinks.map((social, index) => (
                  <a
                    key={index}
                    href={social.href}
                    className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center text-gray-300 hover:bg-primary-500 hover:text-white transition-all duration-300"
                    aria-label={social.label}
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      {/* <div className="border-t border-gray-800 py-6">
        <div className="container-custom">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-gray-400 text-sm">
              © {currentYear} DentalCare Clinic. Tous droits réservés.
            </div>

            <div className="flex flex-wrap justify-center space-x-6 text-sm">
              <a
                href="#"
                className="text-gray-400 hover:text-primary-400 transition-colors duration-300"
              >
                Politique de confidentialité
              </a>
              <a
                href="#"
                className="text-gray-400 hover:text-primary-400 transition-colors duration-300"
              >
                Conditions d'utilisation
              </a>
              <a
                href="#"
                className="text-gray-400 hover:text-primary-400 transition-colors duration-300"
              >
                Avis HIPAA
              </a>
              <a
                href="#"
                className="text-gray-400 hover:text-primary-400 transition-colors duration-300"
              >
                Accessibilité
              </a>
            </div>
          </div>
        </div>
      </div> */}

      {/* Emergency Banner */}
      <div className="bg-red-600 py-3">
        <div className="container-custom text-center">
          <p className="text-white font-semibold">
            🚨 Urgence dentaire ? Appelez le 07 08 44 44 54 - Disponible 24h/24
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 